'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _language = require('../language');

var _Popover = require('../popover/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('rc-color-picker/assets/index.css');

require('./css/iconpicker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorPicker = (0, _component2.default)(function () {
    return import("rc-color-picker/lib/ColorPicker");
});

var IDIconPicker = function (_Component) {
    (0, _inherits3.default)(IDIconPicker, _Component);

    function IDIconPicker(props) {
        (0, _classCallCheck3.default)(this, IDIconPicker);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IDIconPicker.__proto__ || (0, _getPrototypeOf2.default)(IDIconPicker)).call(this, props));

        _this.convertIcon = function (string) {
            var arr = string.replace(/([a-z])([A-Z])/g, '$1 $2').split(" ");
            arr.pop();
            return _lodash2.default.map(arr, function (i) {
                return i.toLowerCase();
            }).join("-");
        };

        _this.handleVisibleChange = function (visible) {
            if (visible !== _this.state.visible) {
                if (!_this.openColor) {
                    _this.setState({ visible: visible });
                }
            }
        };

        _this.state = (0, _extends3.default)({
            value: props.value || {
                name: "",
                background: "#fff",
                color: "#333",
                type: 'antd'
            },
            visible: false
        }, _this.initialState());
        _this.dataTestID = 'icon-picker';
        return _this;
    }

    (0, _createClass3.default)(IDIconPicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!_lodash2.default.isEqual(this.state.value, nextProps.value)) {
                this.setState({ value: nextProps.value });
            }
        }
    }, {
        key: 'initialState',
        value: function initialState() {
            var rawData = [];
            var icons = _ConfigGlobal2.default.iconMap;
            // icons = require(`@ant-design/icons`);
            _lodash2.default.each(icons, function (value, label) {
                rawData.push({
                    label: label,
                    value: value
                });

                // if (typeof value === 'object' && label !== 'default') {
                //     rawData.push({
                //         label: this.convertIcon(label),
                //         value
                //     });
                // }
            });

            var currentPage = 1;
            var pageSize = 42;
            var data = rawData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

            return {
                currentPage: currentPage,
                pageSize: pageSize,
                totalCount: _lodash2.default.size(rawData),
                totalPage: this.getTotalPage(pageSize, rawData),
                rawData: rawData,
                data: data
            };
        }
    }, {
        key: 'getTotalPage',
        value: function getTotalPage(pageSize, rawData) {
            var totalCount = _lodash2.default.size(rawData);
            return Math.ceil(totalCount / pageSize);
        }
    }, {
        key: 'getDisplayData',
        value: function getDisplayData(currentPage) {
            var _state = this.state,
                pageSize = _state.pageSize,
                rawData = _state.rawData;

            return rawData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            var currentPage = this.state.currentPage;
            var totalPage = this.state.totalPage;

            if (currentPage < totalPage) {
                currentPage = currentPage + 1;

                var data = this.getDisplayData(currentPage);
                this.setState({
                    currentPage: currentPage,
                    data: data
                });
            }
        }
    }, {
        key: 'previousPage',
        value: function previousPage() {
            var currentPage = this.state.currentPage;

            if (currentPage > 1) {
                currentPage = currentPage - 1;

                var data = this.getDisplayData(currentPage);
                this.setState({
                    currentPage: currentPage,
                    data: data
                });
            }
        }
    }, {
        key: 'onSelect',
        value: function onSelect(item) {
            var _this2 = this;

            var value = this.state.value;

            value.name = item.label;
            this.setState({
                visible: false,
                value: value
            }, function () {
                _this2.props.onChange && _this2.props.onChange(value);
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var _this3 = this;

            var eles = [];
            var _state2 = this.state,
                data = _state2.data,
                value = _state2.value;
            var size = this.props.size;

            _lodash2.default.each(data, function (item) {
                var IconMap = item.value;
                eles.push(_react2.default.createElement(
                    'div',
                    {
                        className: 'icon-cell',
                        style: {
                            background: _lodash2.default.get(value, 'background'),
                            color: _lodash2.default.get(value, 'color'),
                            height: size,
                            width: size,
                            borderRadius: _this3.props.borderRadius || 3
                        },
                        onClick: function onClick() {
                            _this3.onSelect(item);
                        }
                    },
                    _react2.default.createElement(IconMap, null)
                ));
            });
            return eles;
        }
    }, {
        key: 'renderFilter',
        value: function renderFilter() {}
    }, {
        key: 'renderPaging',
        value: function renderPaging() {
            var _this4 = this;

            var _state3 = this.state,
                currentPage = _state3.currentPage,
                totalPage = _state3.totalPage;

            return _react2.default.createElement(
                'div',
                {
                    style: { display: 'flex' },
                    className: 'icon-picker-pagining'
                },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'button-previous',

                        onClick: function onClick() {
                            return _this4.previousPage();
                        }
                    },
                    _react2.default.createElement(_Icon2.default, { type: 'left' })
                ),
                _react2.default.createElement(
                    'div',
                    { style: { flex: 1, textAlign: 'center' } },
                    currentPage + '/' + totalPage
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'button-next',
                        onClick: function onClick() {
                            return _this4.nextPage();
                        }
                    },
                    _react2.default.createElement(_Icon2.default, { type: 'right' })
                )
            );
        }
    }, {
        key: 'onChange',
        value: function onChange(attr, val) {
            var _this5 = this;

            var value = this.state.value;

            value[attr] = val.color;
            value.type = "antd";
            this.setState({ value: value }, function () {
                if (value.name) {
                    _this5.props.onChange && _this5.props.onChange(value);
                }
            });
        }
    }, {
        key: 'onRemove',
        value: function onRemove() {
            var _this6 = this;

            this.setState({
                value: {
                    name: "",
                    background: "#fff",
                    color: "#333"
                }
            }, function () {
                _this6.props.onChange && _this6.props.onChange(null);
            });
        }
    }, {
        key: 'renderButtonClear',
        value: function renderButtonClear() {
            var _this7 = this;

            var isClearable = this.props.isClearable;

            if (_lodash2.default.get(this.state.value, 'name') && isClearable) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'icon-picker-remove',
                        onClick: function onClick() {
                            return _this7.onRemove();
                        }
                    },
                    _react2.default.createElement(_Icon2.default, { type: 'close' })
                );
            }
            return null;
        }
    }, {
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            var _props = this.props,
                style = _props.style,
                className = _props.className,
                disabled = _props.disabled,
                readOnly = _props.readOnly,
                size = _props.size;

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('icon-picker', className, { 'input-disabled': disabled, 'read-only': readOnly }),
                    style: style
                },
                _react2.default.createElement(
                    _Popover2.default,
                    {
                        dataTestID: this.getDataTestId(),
                        trigger: 'click',
                        placement: this.props.placement || "bottomLeft",
                        destroyTooltipOnHide: true,
                        visible: this.state.visible,
                        onVisibleChange: this.handleVisibleChange,
                        overlayClassName: 'icon-picker-overlay',
                        getPopupContainer: function getPopupContainer(trigger) {
                            return trigger.parentNode.closest('.popup-container') || document.body;
                        },
                        content: _react2.default.createElement(
                            'div',
                            null,
                            this.renderFilter(),
                            _react2.default.createElement(
                                'div',
                                { style: {
                                        display: 'flex',
                                        marginBottom: 5
                                    }
                                },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'button-color', style: { flex: 1 } },
                                    _react2.default.createElement(
                                        'span',
                                        { style: { marginRight: 10 } },
                                        _react2.default.createElement(_language.TextTranslate, { text: 'Background color' })
                                    ),
                                    _react2.default.createElement(ColorPicker, {
                                        animation: 'slide-up',
                                        onOpen: function onOpen() {
                                            _this8.openColor = true;
                                        },
                                        onClose: function onClose() {
                                            _this8.openColor = false;
                                        },
                                        getCalendarContainer: function getCalendarContainer(trigger) {
                                            return trigger.parentNode.closest('.popup-container') || document.body;
                                        },
                                        color: _lodash2.default.get(this.state.value, 'background'),
                                        onChange: function onChange(val) {
                                            return _this8.onChange('background', val);
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'button-color', style: { flex: 1, justifyContent: 'center' } },
                                    _react2.default.createElement(
                                        'span',
                                        { style: { marginRight: 10 } },
                                        _react2.default.createElement(_language.TextTranslate, { text: 'Color' })
                                    ),
                                    _react2.default.createElement(ColorPicker, {
                                        animation: 'slide-up',
                                        onOpen: function onOpen() {
                                            _this8.openColor = true;
                                        },
                                        onClose: function onClose() {
                                            _this8.openColor = false;
                                        },
                                        getCalendarContainer: function getCalendarContainer(trigger) {
                                            return trigger.parentNode.closest('.popup-container') || document.body;
                                        },
                                        color: _lodash2.default.get(this.state.value, 'color'),
                                        onChange: function onChange(val) {
                                            return _this8.onChange('color', val);
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_language.TextTranslate, { text: 'Icon' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { style: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'center'
                                    }
                                },
                                this.renderContent()
                            ),
                            this.renderPaging()
                        )
                    },
                    _react2.default.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        _react2.default.createElement(
                            'div',
                            { style: { position: 'relative' } },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: 'icon-cell-value',
                                    style: {
                                        background: _lodash2.default.get(this.state.value, 'background', undefined),
                                        color: _lodash2.default.get(this.state.value, 'color', undefined),
                                        height: size,
                                        width: size,
                                        borderRadius: this.props.borderRadius || 3,
                                        border: '1px solid ' + (_lodash2.default.get(_lodash2.default.get(this.state.value, 'name')) ? _lodash2.default.get(_lodash2.default.get(this.state.value, 'background')) : "#ddd")
                                    }
                                },
                                _lodash2.default.get(this.state.value, 'name') && _react2.default.createElement(_Icon2.default, { type: _lodash2.default.get(this.state.value, 'name') })
                            ),
                            this.renderButtonClear()
                        ),
                        _react2.default.createElement(
                            'span',
                            {
                                onClick: function onClick() {
                                    _this8.setState({
                                        visible: true
                                    });
                                },
                                className: 'icon-picker-text'
                            },
                            _react2.default.createElement(_language.TextTranslate, { text: this.props.buttonText })
                        )
                    )
                )
            );
        }
    }]);
    return IDIconPicker;
}(_react.Component);

exports.default = IDIconPicker;


IDIconPicker.defaultProps = {
    size: 30,
    isClearable: true,
    buttonText: "Change icon"
};